import { Turbo } from "@hotwired/turbo-rails"

// Custom turbo confirmation modal
Turbo.config.forms.confirm = (message, form, submitter) => {
  const template = document.querySelector("#turbo-confirm-template")
  const modal = template.content.firstElementChild.cloneNode(true)

  modal.dataset.confirmationBodyValue = message
  if (submitter) {
    if (submitter.dataset.confirmTitle) modal.dataset.confirmationTitleValue = submitter.dataset.confirmTitle
    if (submitter.dataset.confirmBodyHtml) modal.dataset.confirmationBodyHtmlValue = submitter.dataset.confirmBodyHtml
    if (submitter.dataset.confirmCancel) modal.dataset.confirmationCancelValue = submitter.dataset.confirmCancel
    if (submitter.dataset.confirmAccept) modal.dataset.confirmationAcceptValue = submitter.dataset.confirmAccept
    if (submitter.dataset.confirmAcceptClass) modal.dataset.confirmationAcceptClass = submitter.dataset.confirmAcceptClass
  }

  document.body.appendChild(modal)

  return new Promise((resolve) => {
    modal.addEventListener("confirmation:close", ({ detail: { confirmed } }) => {
      resolve(confirmed)
      if (!confirmed) form.dispatchEvent(new CustomEvent("turbo-confirm:cancel"))
    }, { once: true })
  })
}
